import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M3 2v6h6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 12A9 9 0 0 0 6 5.3L3 8", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M21 22v-6h-6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M3 12a9 9 0 0 0 15 6.7l3-2.7", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "RefreshCcw";
const RefreshCcw = memo(themed(Icon));
export {
  RefreshCcw
};
//# sourceMappingURL=refresh-ccw.js.map
